import { DispatcherEvent } from '@carvana/merch-native';
import { useContext, useEffect } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { NativeModalId } from '~/context/vdp/ModalContext/constants';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import sendMessageToNative from './sendMessageToNative';

// Tell the native app to open modals
function sendMessageToOpenNativeModal(
  modal: NativeModalId,
  onError: () => void,
  payload: Record<string, any> = {}
) {
  sendMessageToNative(
    DispatcherEvent.OpenModal,
    { modal, ...payload },
    { onError }
  );
}

export default function useModalMessageDispatcher() {
  const {
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isGeolocationModalOpen,
    isMarketValueModalOpen,
    isReservableCancelModalOpen,
    isReturnPolicyModalOpen,
    isSoftPullModalOpen,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setGeolocationModalOpen,
    setMarketValueModalOpen,
    setReservableCancelModalOpen,
    setReturnPolicyModalOpen,
    setSoftPullModalOpen
  } = useContext(ModalContext);
  const {
    fairMarketValue = 0,
    marketValueLoadedDateTime,
    price = 0
  } = useGetVehicleDetails();

  useEffect(() => {
    if (isGeolocationModalOpen) {
      sendMessageToOpenNativeModal(NativeModalId.Geolocation, () => {
        setGeolocationModalOpen(false);
      });
    }

    if (isMarketValueModalOpen) {
      sendMessageToOpenNativeModal(
        NativeModalId.MarketValue,
        () => {
          setMarketValueModalOpen(false);
        },
        {
          fairMarketValue,
          marketValueLoadedDateTime,
          price
        }
      );
    }

    if (isReservableCancelModalOpen) {
      sendMessageToOpenNativeModal(NativeModalId.CancelReservation, () => {
        setReservableCancelModalOpen(false);
      });
    }

    if (isReturnPolicyModalOpen) {
      sendMessageToOpenNativeModal(NativeModalId.ReturnPolicy, () => {
        setReturnPolicyModalOpen(false);
      });
    }

    if (
      isAddCoApplicantModalOpen ||
      isEditCoApplicantModalOpen ||
      isSoftPullModalOpen
    ) {
      sendMessageToOpenNativeModal(NativeModalId.SoftPull, () => {
        setSoftPullModalOpen(false);
        setAddCoApplicantModalOpen(false);
        setEditCoApplicantModalOpen(false);
      });
    }
  }, [
    fairMarketValue,
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isGeolocationModalOpen,
    isMarketValueModalOpen,
    isReservableCancelModalOpen,
    isReturnPolicyModalOpen,
    isSoftPullModalOpen,
    marketValueLoadedDateTime,
    price,
    setAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen,
    setGeolocationModalOpen,
    setMarketValueModalOpen,
    setReservableCancelModalOpen,
    setReturnPolicyModalOpen,
    setSoftPullModalOpen
  ]);
}
